import {
  GET_GROUPS,
} from 'constants/groups';

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_GROUPS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
